/* Pagani Design Chile · efectos globales (todas las páginas)
   - Linterna: la foto se ilumina donde está el cursor (.pd-spot y tarjetas de producto de Dawn)
   - En pantallas táctiles se ilumina la foto que pasa por el centro de la pantalla
   - En la portada, el header pasa de transparente a sólido al terminar el hero */
(function () {
  'use strict';
  var D = document, W = window;

  /* ---------- Linterna ---------- */
  D.addEventListener('pointermove', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var t = e.target;
    if (!t || !t.closest) return;
    var s = t.closest('.pd-spot, .card__media');
    if (!s) return;
    var r = s.getBoundingClientRect();
    if (!r.width || !r.height) return;
    s.style.setProperty('--mx', ((e.clientX - r.left) / r.width) * 100 + '%');
    s.style.setProperty('--my', ((e.clientY - r.top) / r.height) * 100 + '%');
  }, { passive: true });

  var io = null;
  function watchSpots(scope) {
    if (!W.matchMedia('(hover: none)').matches || !('IntersectionObserver' in W)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('is-lit', en.isIntersecting); });
      }, { rootMargin: '-38% 0px -38% 0px' });
    }
    (scope || D).querySelectorAll('.pd-spot').forEach(function (s) { io.observe(s); });
  }

  /* ---------- Filtro de precio en pesos ----------
     En CLP no hay decimales: si alguien escribe "150.000" se deja como 150000,
     para que Shopify no lo interprete como 150 */
  if (W.Shopify && W.Shopify.currency && W.Shopify.currency.active === 'CLP') {
    D.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('price-range')) return;
      var v = t.value.replace(/[^0-9]/g, '');
      if (v !== t.value) t.value = v;
    }, true);
  }

  /* ---------- Header de la portada ---------- */
  var body = D.body;
  var isIndex = body.classList.contains('pd-template-index');
  var ticking = false;
  function headerState() {
    ticking = false;
    var hero = D.querySelector('.pd-hero');
    var limit = 40;
    if (hero) {
      var top = hero.getBoundingClientRect().top + W.scrollY;
      limit = top + hero.offsetHeight - W.innerHeight * 0.35;
    }
    body.classList.toggle('pd-past-hero', W.scrollY > limit);
  }
  function onScroll() {
    if (!ticking) { ticking = true; W.requestAnimationFrame(headerState); }
  }

  function init() {
    watchSpots(D);
    if (isIndex) {
      W.addEventListener('scroll', onScroll, { passive: true });
      W.addEventListener('resize', onScroll);
      headerState();
    }
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();

  /* Editor de temas: volver a observar las fotos de una sección recargada */
  D.addEventListener('shopify:section:load', function (e) {
    watchSpots(e.target);
    if (isIndex) headerState();
  });

  W.PDGlobal = { watchSpots: watchSpots, headerState: headerState };
})();
